import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import { ShieldX, Home, LogOut } from 'lucide-react';
import { Button } from '../components/ui/button';
import Layout from '../components/layout/Layout';

const UnauthorizedPage = () => {
  const { logout, user } = useAuth();
  const { language } = useLanguage();

  return (
    <Layout>
      <div className="min-h-[80vh] flex items-center justify-center bg-slate-50 py-12 px-4">
        <div className="max-w-md w-full text-center">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
              <ShieldX className="w-8 h-8 text-red-600" />
            </div>
            <h2 className="text-3xl font-light text-slate-800 mb-2">
              {language === 'en' ? 'Access Denied' : 'Accès Refusé'}
            </h2>
            <p className="text-slate-500 mb-6">
              {language === 'en' 
                ? 'You are not authorized to access this area. Please contact an administrator.'
                : 'Vous n\'êtes pas autorisé à accéder à cette zone. Veuillez contacter un administrateur.'
              }
            </p>
            
            {user && (
              <div className="bg-slate-50 rounded-lg p-4 mb-6">
                <p className="text-sm text-slate-600">
                  {language === 'en' ? 'Logged in as:' : 'Connecté en tant que:'} 
                  <span className="font-medium"> {user.email}</span>
                </p>
              </div>
            )}

            <div className="flex flex-col sm:flex-row gap-3">
              <Link to="/" className="flex-1">
                <Button variant="outline" className="w-full">
                  <Home className="w-4 h-4 mr-2" />
                  {language === 'en' ? 'Back to Home' : 'Retour à l\'accueil'}
                </Button>
              </Link>
              <Button onClick={logout} variant="destructive" className="flex-1">
                <LogOut className="w-4 h-4 mr-2" />
                {language === 'en' ? 'Logout' : 'Déconnexion'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default UnauthorizedPage;
